<!--  -->
<template>
  <div>
    <div v-if="!showStrategyView">
      <div style="float: right">
        <el-button type="primary" @click="StrategyAdd">新建策略</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column label="名称" prop="strategy_name"></el-table-column>
        <el-table-column label="涉及公众号/人数" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.app_relation_list" :key="index">
              {{ item.app_name + ' ' + item.count + '人' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleView(scope.row)" type="text" v-if="scope.row.status === 1">
              查看
            </el-button>
            <el-button type="text" v-if="scope.row.status === 1" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button type="text" v-if="scope.row.status === 1" @click="handleDelect(scope.row)">
              删除
            </el-button>
            <el-button type="text" v-if="scope.row.status === 1" @click="handleDisable(scope.row)">
              禁用
            </el-button>
            <el-button type="text" v-if="scope.row.status === 2" @click="handleRestore(scope.row)">
              恢复
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; float: right">
        <el-pagination
          @size-change="handleSizeChange"
          style="background-color: #ffffff"
          layout="total,sizes, prev, pager, next, jumper"
          :page-sizes="g_pageSizesConfig"
          :total="total"
          :page-size="page_size"
          :current-page="page_index"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getStrategyList,
  updateStrategyStatus,
  getAppListApi,
  DeleteStrategyInfo,
} from '@/api/setUser.js';
export default {
  filters: {
    optionsAppIdLabel(val, options = []) {
      for (const item of options) {
        if (item.app_id === val) {
          return item.app_name;
        }
      }
      return '';
    },
  },
  data() {
    return {
      strategyData: null,
      showStrategyView: false,
      loading: false,
      page_index: 1,
      page_size: this.g_pageSizeDefault,
      tableData: [],
      appIdList: [],
      app_id: [],
      total: 0,
    };
  },
  created() {
    this.page_size = this.g_pageSizeDefault;
    this.loading = true;
    this.getList();
    getAppListApi()
      .then((res) => {
        this.appIdList = res.list;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
  },
  methods: {
    tableRowClassName(row) {
      if (row.row.status === 2) {
        return 'warning-row';
      }
    },
    handleDelect(row) {
      this.$confirm('确认删除该策略吗', '提示')
        .then(() => {
          DeleteStrategyInfo({ id: row.id })
            .then(() => {
              this.$message.success('删除成功');
              this.getList();
            })
            .catch(() => {
              this.$message.error('删除失败');
            });
        })
        .catch(() => {});
    },
    handleRestore(row) {
      updateStrategyStatus({ id: row.id, status: 1 })
        .then(() => {
          this.$message.success('恢复成功');
          this.getList();
        })
        .catch(() => {});
    },
    handleDisable(row) {
      this.$confirm('确认禁用此策略吗？', '提示')
        .then(() => {
          updateStrategyStatus({ id: row.id, status: 2 })
            .then(() => {
              this.$message.success('禁用成功');
              this.getList();
            })
            .catch(() => {
              this.$message.error('禁用失败');
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      this.$router.push({
        name: 'strategyEdit',
        query: {
          type: 'edit',
          id: row.id,
        },
      });
    },
    handleView(row) {
      // 查看
      this.g_tourl(`/saas/setUser/strategyView.html?id=${row.id}`);
    },
    StrategyAdd() {
      this.$router.push({
        name: 'strategyEdit',
        query: {
          type: 'add',
        },
      });
    },
    getList() {
      this.loading = true;
      getStrategyList({ page_index: this.page_index, page_size: this.page_size })
        .then((res) => {
          this.tableData = res.list;
          this.total = res.total;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.$message);
        });
    },
    strategyBackFun() {
      this.showStrategyView = false;
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  color: #c0c4cc;
}
</style>
